import createMediaService from '../../../common/media/mediaService';

import getClientConfig from '../getClientConfig';

const clientConfig = getClientConfig();

export default createMediaService(clientConfig.mediaServer.apiUrl);
